import React from 'react';
import StatCard from './StatCard';
import styles from './Dashboard.module.css';

const StatsGrid = ({ stats }) => {
    return (
        <div className={styles.statsGrid}>
            {stats.map((stat, index) => (
                <StatCard key={index} stat={stat} />
            ))}
        </div>
    );
};

export default StatsGrid;